
import { css } from 'styled-components'

export default css`
  position: relative;
  white-space: nowrap;

  :before {
    bottom: -1px;
    content: '';
    position: absolute;
    height: 1px;
    width: 100%;
    background-color: currentColor;
    transition: opacity ${ p => p.theme.trsDu.linkUnderline + 'ms' };
  }

  :hover:before {
    opacity: 0;
  }
`
